import {Component}                 from '@angular/core';
import {MatDialogRef}             from '@angular/material/dialog';
import {MatSnackBar}              from '@angular/material/snack-bar';
import {AuthService}              from '@src/app/core/services/auth.service';

@Component({
    standalone: false,
    selector: 'app-marketing-consent-modal',
    templateUrl: './marketing-consent-modal.component.html',
    styleUrls: ['./marketing-consent-modal.component.scss']
})
export class MarketingConsentModalComponent
{
    public loading: boolean = false;

    public constructor(
        private authService: AuthService,
        private snackBar: MatSnackBar,
        private dialogRef: MatDialogRef<MarketingConsentModalComponent>
    )
    {
    }

    public updateMarketingConsent(marketingConsent: boolean): void
    {
        if (this.loading) {
            return;
        }

        this.loading = true;

        this.authService.updateMarketingConsent(marketingConsent).subscribe({
            next: () => {
                this.loading = false;
                this.dialogRef.close(marketingConsent);
            },
            error: () => {
                this.loading = false;
                this.snackBar.open('We could not save your marketing preference. Please try again.', 'Ok', {
                    duration: 4000,
                });
            },
        });
    }
}

